import { InMemoryCache } from '@apollo/client/cache';

const cacheConfig = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        getCompanyResourcesPaginated: {
          keyArgs: ['searchBy', 'resourceCategoryId', 'name', 'resourceType'],
          merge(existing, incoming, { args }) {
            const existingNodes = existing?.nodes ?? [];
            return {
              ...incoming,
              nodes: args?.after ? [...existingNodes, ...incoming.nodes] : incoming.nodes,
            };
          },
        },

        getResourcesForScheduler: {
          keyArgs: ['resourceType', 'searchBy'],
          merge(existing, incoming, { args }) {
            const existingNodes = existing?.nodes ?? [];
            return {
              ...incoming,
              nodes: args?.after ? [...existingNodes, ...incoming.nodes] : incoming.nodes,
            };
          },
        },
      },
    },
  },
});

export default cacheConfig;
